export default __webpack_public_path__ + "static/media/4_Standing up on the inside.e349cf69.jpg";